import { system, PropsOf } from '../../../system'

export type BoxProps = PropsOf<typeof system.div>

export const Box = system('div')({
  boxSizing: 'border-box',
  minWidth: 0
})
